//@flow
import React, { Component } from 'react';
import { ListMobileCarousel } from 'components/molecules/listMobileCarousel';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';
import type { ConstructionGalleryType } from 'types/project';

type Props = {
  constructionGalleryData: Object<ConstructionGalleryType>,
  fetchTitle: Component,
};

const ConstructionGalleryCardMobile = (props: Props) => {
  const { constructionGalleryData, fetchTitle } = props;
  const { height } = useViewport();
  if (!constructionGalleryData.constructionGalleryList) {
    return null;
  }
  return (
    <div className="construction-gallery-mob" style={{ height }}>
      <ListMobileCarousel
        data={constructionGalleryData.constructionGalleryList}
        fetchTitle={fetchTitle}
      />
    </div>
  );
};

export default ConstructionGalleryCardMobile;
